module.exports = __webpack_public_path__ + "static/media/jhPie.a30e94dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/jhPie.png
// module id = 658
// module chunks = 0 1